var exports = {
  "T": "xaf9ae18d--ad10c0--map",
  "L": "xaf9ae18d--ad10c0--toggle",
};

module.exports = exports;
